import React, { useEffect } from "react";
import BreadCrumb from "../../components/template/BreadCrumb";
import Header from "../../components/template/Header";
import Spinner from "../../components/layout/Spinner";
import {
  inputFields,
  PAGE_TITLE,
  PAGE_SINGLE_TITLE,
  LINK_URL,
  SIDEBAR_OPTIONS,
} from "../../shared/enums/activitystatuss_enum";
import SingleView from "../../components/common/SingleView";
import { useSingleActivitystatus } from "../../shared/hooks/UseActivitystatus";
const ViewActivitystatus = ({ match }) => {
  const [data] = useSingleActivitystatus(match.params.id);
  const { activitystatus_loading, activitystatus } = data;
  return (
    <div className="pace-done">
      <div>
        <Header />
        <BreadCrumb
          title={PAGE_SINGLE_TITLE}
          mainLinkTitle={PAGE_TITLE}
          mainLinkUrl={LINK_URL}
          activeLink="View"
        />
        {!activitystatus_loading ? (
          activitystatus && (
            <SingleView
              data={activitystatus}
              inputFields={inputFields}
              label={PAGE_SINGLE_TITLE}
              link={LINK_URL}
              id={activitystatus._id}
              SIDEBAR_OPTIONS={SIDEBAR_OPTIONS}
            />
          )
        ) : (
          <div>
            <Spinner />
          </div>
        )}
      </div>
    </div>
  );
};

export default ViewActivitystatus;
